<ng-container *transloco="let t">
    <ng-container
        *ngIf="{
            required: required$ | async,
            values: values.$ | async,
        } as data"
    >
        <div
            [class]="'bazis-control bazis-control_autocomplete ' + cssClassSizeControl"
            [ngClass]="{
                'bazis-control--activated': showList,
                'bazis-control--dirty': ngControl.control.dirty,
                'bazis-control--empty':
                    emptyValues.indexOf(ngControl.control.value) > -1 ||
                    (multiple && !ngControl.control.value?.length),
                'bazis-control--invalid': ngControl.control.invalid,
                'bazis-control--disabled': isDisabled,
            }"
        >
            <bazis-label
                [isMajor]="hasTitleMajor"
                [isEmptyLabel]="isEmptyLabel"
                [title]="title || t(titleKey, titleParams)"
                [required]="data.required"
            >
                <bazis-interrogation
                    *ngIf="tooltipKey"
                    [slot]="tooltipSettings?.targetSide"
                    iconSize="compact"
                    [tooltipText]="t(tooltipKey, tooltipParams)"
                    [tooltipOffset]="[-8, 4]"
                    [tooltipEventType]="tooltipSettings?.eventType || 'hover'"
                    [tooltipPlacement]="tooltipSettings?.placement || 'top-start'"
                    [icon]="icons.interrogation"
                    [type]="interrogationType"
                ></bazis-interrogation>
            </bazis-label>

            <div
                *ngIf="viewTypeSelected === 'tagsStart'"
                class="bazis-tags-group"
            >
                <ng-container [ngTemplateOutlet]="tplTags"></ng-container>
            </div>

            <!-- Мобильная версия требует доработки -->
            <div
                *ngIf="!isVisibleField && ngControl.value"
                class="bh-hide-sm-up bh-margin-bottom-6x"
            >
                <p class="bh-margin-vertical-2x">
                    <ng-container [ngTemplateOutlet]="tplSelectTrigger"></ng-container>
                </p>
                <bazis-link
                    class="sl-letter-spacing_025"
                    borderStyle="none"
                    (click)="showField($event)"
                    >{{ t('action.change') }}</bazis-link
                >
            </div>

            <div
                #wrapper
                class="bazis-list_control-dd-wrapper"
                [class.bh-events-none]="isDisabled"
                clickOutside
                (clickOutside)="hideList()"
            >
                <div
                    class="bazis-control__field-group"
                    [class.bazis-control__field-group--activated]="showList"
                    [class.bazis-control__field-group--disabled]="isDisabled"
                    [class.bh-hide-sm-down]="!isVisibleField"
                >
                    <bazis-control-field-start
                        [isClickable]="isLeftIconClickable"
                        [icon]="leftIcon"
                        [tooltipText]="t(tooltipKey, tooltipParams)"
                        [tooltipSettings]="tooltipSettings"
                        (actionClick)="onLeftIconClick($event)"
                    >
                    </bazis-control-field-start>

                    <div class="bazis-control__field">
                        <!-- Прекрасный кастомный селект -->
                        <div
                            class="bazis-select"
                            [class.bazis-select_secondary]="type === 'secondary'"
                            (click)="toggleList()"
                        >
                            <div
                                *ngIf="viewTypeSelected === 'inside'"
                                class="bazis-select__trigger"
                            >
                                <span>
                                    <ng-container
                                        [ngTemplateOutlet]="tplSelectTrigger"
                                    ></ng-container>
                                </span>
                            </div>
                            <input
                                #searchInput
                                class="bazis-control__field"
                                [class.bazis-control__field--focused]="
                                    isFocused || (showList && searchControl.value)
                                "
                                [class.bazis-control__field_opacity]="!searchControl.value"
                                [formControl]="searchControl"
                                [mask]="maskSettings?.mask"
                                [patterns]="maskSettings?.patterns"
                                (focus)="focusField()"
                                (blur)="isFocused = false"
                                [placeholder]="placeholderKey ? t(placeholderKey) : ''"
                            />
                        </div>
                    </div>

                    <bazis-control-search-end
                        [tooltipText]="t(tooltipKey, tooltipParams)"
                        [tooltipSettings]="tooltipSettings"
                        [hasSearchIcon]="hasSearchIcon"
                        [multiple]="multiple"
                        [isDisabled]="isDisabled"
                        [canEraserShow]="
                            hasEraser &&
                            (viewTypeSelected === 'inside' || viewTypeSelected === 'empty')
                        "
                        [searchValue]="searchControl.value"
                        [controlValue]="ngControl.control.value"
                        [iconUp]="iconUp"
                        [iconDown]="iconDown"
                        [otherIcon]="rightIcon"
                        [showList]="showList"
                        (erased)="onClear()"
                        (toggled)="toggleList()"
                        (hideListMobile)="hideListMobile()"
                    ></bazis-control-search-end>
                </div>

                <div class="bazis-control__error">
                    <bazis-form-error [formControl]="ngControl.control"></bazis-form-error>
                    <ng-content select="error"></ng-content>
                </div>

                <div
                    *ngIf="noteKey"
                    class="bazis-control__note"
                >
                    {{ noteKey }}
                </div>

                <ng-content select="note"></ng-content>

                <div
                    #listHint
                    class="bh-popper-z-index"
                    *ngIf="!loadListOnClick || showList"
                    [hidden]="!showList"
                    (click)="clickPopper()"
                >
                    <ng-container *ngIf="filteredList$ | async as list">
                        <div
                            class="bazis-infinite-scroll-content"
                            *ngIf="list?.length > 0 || emptyListKey"
                        >
                            <div class="bazis-list bazis-list_control-dd">
                                <ng-container
                                    *ngFor="let item of list; let i = index; trackBy: trackById"
                                >
                                    <bazis-multiple-selection-item
                                        [item]="item"
                                        [infiniteListTpl]="infiniteListTpl"
                                        [multiple]="multiple"
                                        [valuesMap]="valuesMap"
                                        (toggled)="toggleValue(item.id)"
                                    ></bazis-multiple-selection-item>
                                </ng-container>
                                <div
                                    *ngIf="!list?.length"
                                    class="bazis-item bh-events-none"
                                >
                                    {{ emptyListKey || 'title.emptySearch' | transloco }}
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>

            <div
                *ngIf="viewTypeSelected === 'tagsEnd'"
                class="bazis-tags-group bh-margin-top-2x"
            >
                <ng-container [ngTemplateOutlet]="tplTags"></ng-container>
            </div>
        </div>

        <ng-template #tplSelectTrigger>
            <ng-container *ngFor="let value of values.$ | async; let i = index">
                <ng-container *ngIf="!value">{{
                    placeholderKey ? t(placeholderKey) : ''
                }}</ng-container>

                <bazis-autocomplete-selected-value
                    [infiniteListTpl]="infiniteListTpl"
                    [selectedValueTpl]="selectedValueTpl"
                    [entity]="staticOptionsEntitiesMap[value]"
                    [valuesLength]="values._.length"
                    [index]="i"
                ></bazis-autocomplete-selected-value>
            </ng-container>
        </ng-template>

        <ng-template #tplTags>
            <div
                class="bazis-tag"
                *ngFor="let value of data.values"
            >
                <span>
                    <ng-container
                        *ngIf="infiniteListTpl"
                        [ngTemplateOutlet]="infiniteListTpl"
                        [ngTemplateOutletContext]="{ item: staticOptionsEntitiesMap[value] }"
                    ></ng-container>
                    <ng-container *ngIf="!infiniteListTpl">{{
                        staticOptionsEntitiesMap[value].$snapshot.name
                    }}</ng-container>
                </span>
                <button
                    *ngIf="!isDisabled"
                    (click)="toggleValue(value)"
                >
                    <bazis-icon
                        [name]="icons.trash"
                        size="mini"
                    ></bazis-icon>
                </button>
            </div>
        </ng-template>
    </ng-container>
</ng-container>
